import Vue from "vue";
import vuex from "vuex";
Vue.use(vuex);

export default new vuex.Store({
  state: {
    show: false,
    web3Instance: '',
    web3: null,
    ethersprovider: '',
    ethAddress:'',
    ethChainID: '',
    WalletName:'',
    WalletConnectprovider: ''
  },
  mutations: {
    changeShow(state, show) {
      // alert("bbb");
      state.show = show;
    },
    changeWeb3(state, instance) {
      state.web3Instance = instance;
    },
    changeweb3(state, obj) {
      console.log('changeweb3');
      state.web3 = obj.web3;
      state.ethersprovider = obj.ethersprovider;
    },
    changeEthAddress(state, address) {
      state.ethAddress = address;
    },
    changeEthChainID(state, id) {
      state.ethChainID = id;
    },
    WalletName(state, name){
      state.WalletName = name;
    },
    changeWalletConnectprovider(state, Connectprovider){
      state.WalletConnectprovider = Connectprovider;
    },
  },
  actions: {
    setShow({ commit }, show) {
      commit("changeShow", show);
    }
  }
});
